var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumb)?_c('app-breadcrumb',{attrs:{"items":_vm.breadcrumb.concat( _vm.append)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }